module.exports = __webpack_public_path__ + "img/delete_row.4ef20de6.svg";